import React from 'react'
import classNames from 'classnames'
import { User, Shirt, Camera, TreesIcon, Trees } from 'lucide-react'
import { isMobile } from 'react-device-detect'

interface StepIndicatorProps {
  currentStep: number
}

// 사용자에게 보여줄 3단계
const steps = [
  {
    number: 1,
    title: '장소 · 테마',
    icon: <Trees size={20} />,
  },
  {
    number: 2,
    title: '패션 모델',
    icon: <User size={20} />,
  },
  {
    number: 3,
    title: '옷 선택',
    icon: <Shirt size={20} />,
  },
  {
    number: 4,
    title: '스타일 샷 세트',
    icon: <Camera size={20} />,
  },
]

// 내부 currentStep을 표시 단계로 매핑하는 함수
const mapCurrentStepToDisplayStep = (currentStep: number): number => {
  if (currentStep === 1) return 1 // 테마
  if (currentStep >= 2 && currentStep <3 ) return 2 // 모델 
  if (currentStep >=3 && currentStep <=5) return 3 // 옷 선택
  if (currentStep >= 6 && currentStep <= 7) return 4 // 포토 세트
  return 1
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
}) => {
  const displayStep = mapCurrentStepToDisplayStep(currentStep)

  if (isMobile) {
    // 모바일 가로 레이아웃
    return (
      <div className="flex flex-col gap-2">
        <div
          className="flex items-center justify-center gap-1 rounded-xl px-2 py-2"
          style={{
            background: 'linear-gradient(to right, #6095FF,#D512E7)',
          }}
        >
          <p className="text-[12px] text-white">서비스 오픈 기념</p>
          <p className="text-[16px] font-bold text-white">🌟 90% 할인 🌟</p>
          <p className="text-[16px] font-bold text-white">~11월 30일</p>
        </div>
        <div className="flex w-full gap-1 md:pb-4">
          {steps.map((step) => {
            const isActive = displayStep === step.number
            const isCompleted = displayStep > step.number
            const isUpcoming = displayStep < step.number

            return (
              <div
                key={step.number}
                className={classNames(
                  'flex items-center gap-1 rounded-lg px-4 py-2 transition-colors duration-300',
                  {
                    'bg-[#E7F3F3]': isActive,
                    'bg-transparent': !isActive,
                  },
                )}
              >
                {/* 단계 번호 */}
                <div
                  className={classNames(
                    'flex h-[22px] w-[22px] items-center justify-center rounded-full text-sm font-bold',
                    {
                      'bg-[#00B7B9] text-white': isActive || isCompleted,
                      'bg-[#EEF1F7] text-[#8F929B]': isUpcoming,
                    },
                  )}
                >
                  {step.number}
                </div>

                {/* 아이콘 */}
                <div
                  className={classNames('', {
                    'text-[#2E343D]': isActive || isCompleted,
                    'text-[#8F929B]': isUpcoming,
                  })}
                >
                  {step.icon}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  // 데스크톱 세로 레이아웃
  return (
    <div className="flex w-[180px] shrink-0 flex-col gap-4">
      {steps.map((step) => {
        const isActive = displayStep === step.number
        const isCompleted = displayStep > step.number
        const isUpcoming = displayStep < step.number

        return (
          <div
            key={step.number}
            className={classNames(
              'flex items-center gap-1 rounded-lg p-2 transition-colors duration-300',
              {
                'bg-[#E7F3F3]': isActive,
                'bg-transparent': !isActive,
              },
            )}
          >
            {/* 단계 번호 */}
            <div
              className={classNames(
                'flex h-[22px] w-[22px] items-center justify-center rounded-full text-sm font-bold',
                {
                  'bg-[#00B7B9] text-white': isActive || isCompleted,
                  'bg-[#EEF1F7] text-[#8F929B]': isUpcoming,
                },
              )}
            >
              {step.number}
            </div>

            {/* 아이콘 */}
            <div
              className={classNames('', {
                'text-[#2E343D]': isActive || isCompleted,
                'text-[#8F929B]': isUpcoming,
              })}
            >
              {step.icon}
            </div>

            {/* 제목 */}
            <span
              className={classNames('text-base font-bold', {
                'text-[#2E343D]': isActive || isCompleted,
                'text-[#8F929B]': isUpcoming,
              })}
            >
              {step.title}
            </span>
          </div>
        )
      })}
      <div
        className="flex flex-col items-center rounded-xl py-2"
        style={{
          background: 'linear-gradient(to right, #6095FF,#D512E7)',
        }}
      >
        <p className="text-white">서비스 오픈 기념</p>
        <p className="text-[20px] font-bold text-white">🌟 90% 할인 🌟</p>
        <p className="text-[14px] font-bold text-white">~11월 30일</p>
      </div>
    </div>
  )
}
